<div class="alert alert-dismissible fade show" [ngClass]="message.type === 'INFO' ? 'alert-info': 'alert-danger'" role="alert"
    *ngFor="let message of messages()">
    <button type="button" class="close" (click)="remove(message)">
        <span aria-hidden="true">&times;</span>
    </button> {{message.text}}
</div>
